import { Languages } from "../../types";
import { consultationTypeDictionary } from "./ConsultationType";
import { createConsultationTypeDictionary } from "./CreateConsultationType";
import { SettingsMedicalAreaDescriptions } from "./types";

export const getSettingsMedicalAreaDescriptions = (systemLang: Languages): SettingsMedicalAreaDescriptions => ({
    CREATE_CONSULTATION_TYPE: createConsultationTypeDictionary[systemLang],
    CONSULTATION_TYPE: consultationTypeDictionary[systemLang],
})